import React from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { TbReportAnalytics } from "react-icons/tb";
import { LuMedal } from "react-icons/lu";
import { IoSpeedometerOutline } from "react-icons/io5";
import { GrDocumentUpload } from "react-icons/gr";
import { TbFilePencil, TbReport } from "react-icons/tb";
import { YearDD } from "../../ReusableComponents/CommonApis";
import { uselocation } from "react-router-dom";
import { AssessmentNameDates } from "../../ReusableComponents/CommonComponents";
import { FaAnglesLeft } from "react-icons/fa6";
import { useSelector } from "react-redux";
const PrincipleMenu = (props) => {
  const navigate = useNavigate();
  const location = useLocation();
  const isActive = (path) => location.pathname.includes(path);
    const SelectDate = useSelector((state) => state.DateDetailsData.DateDetails);
  return (
    <>
      <div className="Sub-Header">
        {/* SelectDate?.assessmentType === 3 &&  */}
        {(location?.pathname === "/Principle/SamagraDashboard" ) ? <></>:<>
        <div className="dflex JCCenter alignitems">
          <div onClick={() => navigate("/PrincipleDashboard")}
            className={!props.CheckPath("/PrincipleDashboard") ? "TabNotSelect" : "SubTabSelect"} >
            <IoSpeedometerOutline /> Dashboard
          </div>

          <div onClick={() => navigate("/TeacherDashboard/StudentInformation/StudentDetails")}
            className={props.CheckPath("StudentDetails") ? "SubTabSelect" : "TabNotSelect"} >
            <TbFilePencil /> Registrations
          </div>

          <div onClick={() => navigate("/TeacherDashboard/StudentInformation/AutobulkRegistrations")}
            className={props.CheckPath("/TeacherDashboard/StudentInformation/AutobulkRegistrations",) ? "SubTabSelect" : "TabNotSelect"} >
            <GrDocumentUpload /> Bulk Registrations
          </div>


          <div onClick={() => navigate("/PrinciplePerformance")}
            className={props.CheckPath("/PrinciplePerformance") || (props.CheckPath("/TeacherDashboard") && !props.CheckPath("/StudentInformation"))
              ? "SubTabSelect" : "TabNotSelect"} >
            <IoSpeedometerOutline /> Performance
          </div>

          <div onClick={() => navigate("/PrincipleParticipation")}
            className={props.CheckPath("/PrincipleParticipation") ? "SubTabSelect" : "TabNotSelect"} >
            <LuMedal /> Participation
          </div>

          <div onClick={() => navigate("/TeacherDashboard/StudentInformation/Results/AssessmentResults",)}
            className={props.CheckPath("/Results") || props.CheckPath("/ViewAnswerSheet") ||
              props.CheckPath("/LoPerformanceReport") || props.CheckPath("/Samagra/LoPerformance")
              ? "SubTabSelect" : "TabNotSelect"} >
            <TbReportAnalytics /> Results </div>

          <div onClick={() => navigate("/Principle/PrincipleReportCard")}
            className={props.CheckPath("/PrincipleReportCard") ? "SubTabSelect" : "TabNotSelect"} >
            <TbReport /> Report Cards </div>
        </div>
</>}
        {/* {!isActive("/PrincipleDashboard") && !isActive("/AutobulkRegistrations") && !isActive("/StudentInformation/StudentDetails") &&
          <div className="dflex JSBetween alignitems">
            {!isActive("/PrinciplePerformance") && !isActive("/PrincipleParticipation") &&
              !isActive("/Results/AssessmentResults") && !isActive("/PrincipleReportCard") &&
              !isActive("/TeacherDifficultyLevel") &&
              !isActive("/TeacherDiffLevel") && !isActive("/PerformanceByeachSubject")
              ? <button className="BackNavigation Buttons dflex" onClick={() => navigate(-1)} > <FaAnglesLeft /> Back </button>
              : <div></div>}

            {!isActive("/StudentInformation") && !isActive("/PrincipleAnswerSheetDetails") &&
              !isActive("/ViewAnswerSheetDetails") && !isActive("/LoPerformance") &&
              <AssessmentNameDates Path={location.pathname} />}
            <div className="" style={{ justifyContent: "end" }}>
              {
                !isActive("/ViewAnswerSheetDetails") && !isActive("/LoPerformance") && !isActive("/Studentwiseresults") &&
                !isActive("/Remediation") && !isActive("/Samagra/LoPerformance") && !isActive("/Question%20Paper") &&
                <YearDD />
              }
            </div>
          </div>
        } */}
      </div>
    </>
  );
};
export default PrincipleMenu;
